import { useState, useCallback, useMemo } from 'react';
import { Input, Select } from 'antd';
const TextArea = Input.TextArea;

//* HOC's
import { withDataContext, withLanguageContext } from 'context';

//* Components
import Page from 'components/common/Page';
import Text from 'components/common/Text';
import Icon from 'components/common/Icon';
import Button from 'components/common/Button';
import FormItem from 'components/common/FormItem';
import Container from 'components/common/Container';
import FormInput from 'components/common/FormInput';
import FormContainer from 'components/common/FormContainer';
import FormSelect from 'components/common/FormSelect';

//* Style
import ContactStyle from 'styles/pages/ContactStyle';

const Contact = ({ pages, pageParams, selectedLang, translate, contact }) => {
	//! State
	const [isSend, setIsSend] = useState(false);

	//! Page Data
	const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, selectedLang, pageParams.name]);

	const onFormSubmit = useCallback(
		(data) => {
			setIsSend('loading');

			return contact(data)
				.then(() => {
					setIsSend(true);

					setTimeout(() => {
						setIsSend(false);
					}, 3000);
				})
				.catch((err) => {
					setIsSend(false);

					return Promise.reject(err);
				});
		},
		[contact]
	);

	return (
		<Page
			meta={pageData?.meta}
			transparentHeader={pageParams.transparentHeader}>
			{pageData ? (
				<ContactStyle>
					<Container>
						<div className='contact-container'>
							{isSend && isSend !== 'loading' ? (
								<div className='success-container'>
									<div className='success-panel'>
										<Icon
											name={'check'}
											className={'success-icon'}
										/>
									</div>
									<div className='success-panel-text'>
										<Text
											className={'h6 error-message font-ping-medium'}
											text={'thankYouContact'}
										/>
										<Text
											className={'pS font-ping-medium'}
											text={'messageSentSuccessfullyContact'}
										/>
									</div>
								</div>
							) : (
								<>
									<Text
										tag={`h1`}
										className={`contact-title h4 font-ping-medium`}
										text={pageData.form.title}
									/>
									<Text
										tag={`h2`}
										className={`contact-subtitle p pS font-ping-medium`}
										text={pageData.form.description}
									/>
									<FormContainer
										onFinish={onFormSubmit}
										className='contact-form'>
										<FormItem
											name={'subject'}
											hasFeedback={false}>
											<FormSelect
												size='large'
												suffixIcon={<Icon name={'dropdown'} />}
												placeholder={`${translate('subjectPlaceholder')}*`}>
												<Select.Option value={'General Inquiry'}>
													{translate('subjectOption1')}
												</Select.Option>
												<Select.Option value={'Partnership Opportunities'}>
													{translate('subjectOption2')}
												</Select.Option>
												<Select.Option value={'Media/Press Inquiry'}>
													{translate('subjectOption3')}
												</Select.Option>
												<Select.Option value={'Feedback'}>
													{translate('subjectOption4')}
												</Select.Option>
											</FormSelect>
										</FormItem>

										<FormItem name={'name'}>
											<FormInput
												type={'text'}
												placeholder={`${translate('name')}*`}
											/>
										</FormItem>

										<FormItem
											name={'email'}
											validationType={'email'}>
											<FormInput
												type={'email'}
												placeholder={`${translate('email')}*`}
											/>
										</FormItem>

										<FormItem name={'message'}>
											<TextArea
												rows={5}
												type={'text'}
												placeholder={`${translate('message')}*`}
											/>
										</FormItem>

										<Button
											className='contact-btn'
											type='icon-aside'
											text='submit'
											icon='arrow'
											disabled={isSend === 'loading'}
											isBtnLoad={isSend === 'loading'}
										/>
									</FormContainer>
								</>
							)}
						</div>
					</Container>
				</ContactStyle>
			) : null}
		</Page>
	);
};

export default withDataContext(withLanguageContext(Contact, ['translate']), ['pages', 'contact']);
